import React from 'react'
import { Spin } from 'antd'
const Spinner = () => {
  return <Spin tip="Loading" fullscreen size="large" />
}
export default Spinner
